const severity = { critical: 4, high: 3, medium: 2, low: 1, none: -1 };

export { severity };
